import React from 'react'
import useUserMutations from '../../../hooks/use-user-mutations'
import useToasts from '../../../hooks/use-toasts'
import useConfirmationDialog from '../../../hooks/use-confirmation-dialog'
import Button from '../../common/spinner-button'
import useCurrentUser from '../../../hooks/use-current-user'

const DeleteUserButton = ({
    userId,
    onClick = () => {},
    children,
    ...props
}) => {

    const { canMessage, isAdmin } = useCurrentUser()

    const {
        toastSuccess,
        toastError,
    } = useToasts({
        successMessage: 'User deleted!',
        errorMessage: 'Error deleting user.',
        onSuccess: onClick,
    })

    const {
        deleteUser,
        isDeleting,
    } = useUserMutations({
        onSuccess: toastSuccess,
        onError: toastError,
    })

    const { showConfirmation } = useConfirmationDialog({
        title: 'Are you sure?',
        description: 'This cannot be undone.',
        onConfirm: () => deleteUser(userId)
    })

    if (!isAdmin) {
        return null
    }

    return (
        <Button
            busy={isDeleting}
            disabled={isDeleting}
            onClick={() => showConfirmation()}
            {...props}
        >
            {children}
        </Button>
    )
}

export default DeleteUserButton